import { ExternalLink } from 'lucide-react';
import { cn } from '../../utils/cn';
import tindisaLogo from '../../assets/images/TindisaLogo_121.jpg';

interface TindisaPartnerLinkProps {
  /** Texte court affiché avant le logo (ex. « Vendez aussi sur »). Optionnel. */
  label?: string;
  /** Taille du logo : `sm` pour les espaces contraints (modal), `md` par défaut. */
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Accès direct au marché partenaire Tindisa (https://tindisa.com).
 *
 * Partenariat Wanzo × Tindisa : les PME utilisatrices de Wanzo accèdent à un
 * vaste marché directement depuis la messagerie (« Votre marché dans la
 * messagerie »). Le logo est posé sur une pastille blanche afin de rester
 * lisible sur n'importe quel fond — clair (pages, modal) comme foncé (cartes).
 */
export function TindisaPartnerLink({ label, size = 'md', className }: TindisaPartnerLinkProps) {
  return (
    <a
      href="https://tindisa.com/"
      target="_blank"
      rel="noopener noreferrer"
      title="Ouvrir le marché Tindisa — votre marché dans la messagerie"
      className={cn(
        'group inline-flex items-center gap-2 rounded-full bg-white border border-gray-200',
        'py-1.5 pl-3 pr-2.5 shadow-sm hover:shadow-md hover:border-orange-300',
        'transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400',
        className,
      )}
    >
      {label && (
        <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-400 group-hover:text-gray-600 whitespace-nowrap transition-colors">
          {label}
        </span>
      )}
      <img
        src={tindisaLogo}
        alt="Tindisa"
        loading="lazy"
        className={cn('w-auto object-contain', size === 'sm' ? 'h-4' : 'h-5 sm:h-6')}
      />
      <ExternalLink className="w-3.5 h-3.5 flex-shrink-0 text-gray-300 group-hover:text-orange-500 transition-colors" />
    </a>
  );
}
